<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        :todo-list.sync="todoList"
        show-to-do
        @reloadData="requestData()"
        @task="taskFun"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-input
              v-model="masterList.tableQuery.search.certificateNo"
              placeholder="请输入专卖证号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-input
              v-model="masterList.tableQuery.search.phone"
              placeholder="请输入电话"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="addFun"
        @edit="editFun(arguments)"
        @view="viewFun(arguments)"
        @delete="deleteFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
        @cancelLink="cancelLinkFun(arguments)"
      />
    </div>
    <!-- 新增 修改 查看-->
    <add-edit-view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditViewTitle"
      :dialog-visible.sync="dialogAddEditViewVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
    <!-- 待办列表 -->
    <task-list-dialog
      :dialog-visible.sync="dialogTaskVisible"
      dialog-title="待认证用户"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 新增 修改
import AddEditViewDialog from './components/addEditViewDialog'
// 代办
import taskListDialog from './components/taskListDialog'
// 数据请求
import { loadAppUserListDataApi, loadAppUserExportDataApi, saveOrUpdateAppUserApi, findAppUserCountByConditionApi } from '@/api/appUser'

export default {
  name: 'AppUser',
  components: {
    CustomTable,
    TableOperation,
    AddEditViewDialog,
    taskListDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'app_user_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['app_user_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['app_user_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['app_user_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['app_user_del'],
            prop: 'delete',
            label: '作废',
            method: 'delete'
          },
          {
            permissionSigns: ['app_user_uncheck'],
            prop: 'cancelLink',
            label: '取消关联',
            method: 'cancelLink'
          },
          {
            permissionSigns: ['app_user_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            certificateNo: '',
            phone: ''
          }
        }
      },
      id: null, // 选中的单据ID
      eventType: '',
      dialogAddEditViewTitle: '',
      dialogAddEditViewVisible: false,
      // 待办
      todoList: [
        {
          permissionSigns: ['app_user_check'],
          label: '待认证用户信息',
          method: 'task',
          count: 0
        }
      ],
      dialogTaskVisible: false,
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'id', filterColumn: 'r.id', label: '编号', width: 80 },
      // { prop: 'wxOpenId', filterColumn: 'wx_open_id', label: '微信OPENID', width: 140 },
      { prop: 'unionId', filterColumn: 'r.union_id', label: '微信统一ID', width: 140 },
      { prop: 'name', filterColumn: 'r.name', label: '名称', width: 120 },
      { prop: 'phone', filterColumn: 'r.phone', label: '电话', width: 120 },
      { prop: 'sexStr', filterColumn: 'r.sex', filterValue: 'sex', label: '性别', width: 110, filterArray: [{ label: '男', value: 1 }, { label: '女', value: 2 }] },
      { prop: 'provinceName', filterColumn: 'r.province_name', label: '省区', width: 120 },
      { prop: 'cityName', filterColumn: 'r.city_name', label: '城市', width: 120 },
      { prop: 'countyName', filterColumn: 'r.county_name', label: '区县', width: 120 },
      { prop: 'benxiangStoreNo', filterColumn: 'r.benxiang_store_no', label: '本香门店码', width: 160 },
      { prop: 'storeName', filterColumn: 'r.store_name', label: '店名', width: 120 },
      { prop: 'certificateNo', filterColumn: 'r.certificate_no', label: '专卖证号', width: 160 },
      { prop: 'ownerName', filterColumn: 'r.owner_name', label: '店主名称', width: 120 },
      { prop: 'ownerPhone', filterColumn: 'r.owner_phone', label: '店主电话', width: 120 },
      { prop: 'address', filterColumn: 'r.address', label: '专卖证地址', width: 180 },
      { prop: 'realAddress', filterColumn: 'r.real_address', label: '实际地址', width: 180 },
      { prop: 'tagName', filterColumn: 'r.tag_name', label: '标签', width: 160 },
      { prop: 'createDateStr', filterColumn: 'r.create_date', label: '注册日期', width: 120 },
      { prop: 'lastLoginTimeStr', filterColumn: 'r.last_login_time', label: '最近登录日期', width: 140 },
      { prop: 'integral', filterColumn: 'r.integral', label: '可用成长值', width: 140 },
      { prop: 'totalIntegral', filterColumn: 'r.total_integral', label: '累计成长值', width: 140 },
      { prop: 'scanIntegral', filterColumn: 'r.scan_integral', label: '推荐可用积分', width: 140 },
      { prop: 'totalScanIntegral', filterColumn: 'r.total_scan_integral', label: '推荐累计积分', width: 140 },
      { prop: 'statusStr', filterColumn: 'r.status', filterValue: 'status', label: '状态', width: 200, filterArray: [{ label: '未认证', value: 1 }, { label: '停用', value: 2 }, { label: '已认证', value: 3 }] },
      { prop: 'affirmCertificateNo', filterColumn: 's.certificate_no', label: '认证专卖证号', width: 160 },
      { prop: 'affirmStoreName', filterColumn: 's.store_name', label: '认证专卖证店名', width: 160 },
      { prop: 'affirmRealStoreName', filterColumn: 's.real_store_name', label: '认证实际店名', width: 160 },
      { prop: 'affirmBenxiangStoreNo', filterColumn: 's.benxiang_store_no', label: '认证本香门店码', width: 180 },
      { prop: 'affirmOldBenxiangStoreNo', filterColumn: 's.old_benxiang_store_no', label: '认证本香门店码(旧)', width: 180 },
      { prop: 'affirmOwnerName', filterColumn: 's.owner_name', label: '认证店主', width: 160 },
      { prop: 'affirmPhone', filterColumn: 's.phone', label: '认证店主电话', width: 160 },
      { prop: 'affirmAddress', filterColumn: 's.address', label: '认证专卖证地址', width: 180 },
      { prop: 'affirmRealAddress', filterColumn: 's.real_address', label: '认证实际地址', width: 180 },
      { prop: 'remark', filterColumn: 'r.remark', label: '备注', width: 200 },
      { prop: 'operatorName', filterColumn: 'r.operator_name', label: '操作人', width: 150 },
      { prop: 'operationTimeStr', filterColumn: 'r.operation_time', label: '操作时间', width: 160, isBetween: true },
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadAppUserListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
      this.getTodoCount()
    },
    // 获取待办任务数量
    getTodoCount () {
      let params = { type: 1, status: 1 }
      findAppUserCountByConditionApi(params).then(res => {
        this.todoList[0].count = res.data ? res.data : 0
      })
    },
    taskFun () {
      this.dialogTaskVisible = !this.dialogTaskVisible
    },
    // 新增
    addFun () {
      this.eventType = 'add'
      this.dialogAddEditViewVisible = !this.dialogAddEditViewVisible
      this.dialogAddEditViewTitle = '新增用户'
    },
    // 修改
    editFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'edit'
      this.dialogAddEditViewVisible = !this.dialogAddEditViewVisible
      this.dialogAddEditViewTitle = '修改用户'
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'view'
      this.dialogAddEditViewVisible = !this.dialogAddEditViewVisible
      this.dialogAddEditViewTitle = '查看用户'
    },
    // 作废
    deleteFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确定作废该用户？', '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }
      ).then(async () => {
        saveOrUpdateAppUserApi({ id: args[0].id, isDel: "1" }).then(res => {
          if (res.mark === '200') {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 取消关联
    cancelLinkFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确定该用户取消关联零售户？', '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }
      ).then(async () => {
        saveOrUpdateAppUserApi({ id: args[0].id, isCancelLink: "1" }).then(res => {
          if (res.mark === '200') {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadAppUserExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
